import axios from "axios";
import router from '../router/index'

if (process.env.NODE_ENV == 'development') { 
    axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV == 'debug') {    
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV == 'production') {    
    axios.defaults.baseURL =GlodbaseInfo.env=='pro'?GlodbaseInfo.proHttpUrl:GlodbaseInfo.devHttpUrl;
}
axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.post['Content-Type'] = 'application/json';

/** 
 * 请求拦截器 
 * 每次请求前，如果存在token则在请求头中携带token 
 */
 axios.interceptors.request.use(
    config => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况        
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token        
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码        
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。        
        const token = localStorage.getItem('header')||'';
        token && (config.headers.signature = token);
        return config;
    },
)


axios.interceptors.response.use(
    // 请求成功
    
    res =>{ 
        res = res.data
        res.status === 200 ? '' : errorHandle(res.status, res.msg); 
        return res
    },
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围 
            errorHandle(response.status, response.statusText);
            return Promise.reject(response);
        } else {
            // 处理断网的情况
            // eg:请求超时或断网时，更新state的network状态
            // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
            // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
            if (!window.navigator.onLine) {
                tip("网络有些波动，请稍后");
            } else {
                return Promise.reject(error);
            }
        }
    });


/** 
 * 请求失败后的错误统一处理 请求成功除200外的处理
 * @param {Number} status 请求失败的状态码
 * @param {String} other 请求失败的描述
 */
 const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
            tip('登录过期，请重新登录');
            break;
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
            tip('登录过期，请重新登录');
            break;
        // 404请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        default:
            tip(other);
    }
 }

 
import Vue from 'vue';
let v = new Vue();
const tip = msg => {
    v.$message({
        showClose: true,
        message: msg,
        type: 'error',
        duration: 3000
    })
}
 



const get = (url, params)=> {
    params = params || {};
    return new Promise((resolve,reject)=>{
        axios.get(url, {
            params: params
        }).then(res=>{
            if(res.status===200){
                resolve(res.data);
            }else if(res.msg.indexOf('登录')>-1){
                router.push({path:'/login'})
                reject(res.data)
            }else{
                reject(res.data)
            }
        }).catch(error=>{
            reject(error)
        })
    })
}
const post = (url,params)=>{
params = params || {};
let postParams = new URLSearchParams(params)
//     params.append('um',this.user||'admin')
//     params.append('pw',this.pwd||'87654321')
return new Promise((resolve,reject)=>{
    axios.post(url,params).then(res=>{
        if(res.status===200){
            resolve(res.data);
        }else if(res.msg.indexOf('登录')>-1){
            router.push({path:'/login'})
            reject(res.data)
        }else{
            reject(res.data)
        }
    }).catch(error=>{
        reject(error)
    })
})
}
const http = {}
http.get = get
http.post = post
export default  http


// WEBPACK FOOTER //
// ./src/api/request.js